import {registerMaterialGraphNode} from "#material/register"
import type {MaterialGroupSockets} from "#material/nodes/base/group/definition"
import {materialGroupDefinition} from "#material/nodes/base/group/definition"
import {MaterialNode} from "#material/nodes/base/material/material-node"
import type {CyclesReturns} from "#material/sockets/cycles"
import type {ThreeReturns} from "#material/sockets/three"
import type {ThreeEvaluator, CyclesEvaluator} from "#material/nodes/base/material/types/evaluators"

@registerMaterialGraphNode
export class MaterialGroup extends MaterialNode<MaterialGroupSockets> {
    public override get definition() {
        return materialGroupDefinition
    }

    override toThree = async (evaluator: ThreeEvaluator): Promise<ThreeReturns<MaterialGroupSockets>> => {
        throw new Error("Three support for MaterialGroup is not implemented.")
    }

    override toCycles = async (evaluator: CyclesEvaluator): Promise<CyclesReturns<MaterialGroupSockets>> => {
        throw new Error("Cycles support for MaterialGroup is not implemented.")
    }
}
